"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriorYearExportFileResponseDto = void 0;
class PriorYearExportFileResponseDto {
    fileName;
    schoolYear;
    s3Key;
    lastModified;
    size;
}
exports.PriorYearExportFileResponseDto = PriorYearExportFileResponseDto;
